import styled from "styled-components"

export const Container = styled.div`
  background: red;
`
Container.defaultProps = {}
